import { isUserActive } from '../utils/index.js';
const changeState = (game, state, request, stateMachine) => {
    const { stateName, userId } = request.payload;
    if (!isUserActive(userId, game.players, state.activeSide)) {
        throw 'User is not active';
    }
    return stateMachine.changeState(state, stateName);
};
export default changeState;
